import { useEffect, useState } from "react";

// Текущее время, обновляется раз в `intervalMs`: для счётчиков «прошло 0:14».
export const useNow = (intervalMs = 1000): number => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => {
      setNow(Date.now());
    }, intervalMs);
    return () => {
      clearInterval(timer);
    };
  }, [intervalMs]);
  return now;
};
